<template>
  <AgreementPop
    :show="show"
    :value="value"
    title="壹心理鲸币使用规则"
    checkText="我已阅读并确认鲸币账户协议"
    @input="handleAgree"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <Protocol></Protocol>
  </AgreementPop>
</template>

<script>
import AgreementPop from '../index'
import Protocol from './Protocol'

export default {
  name: 'SEPA',
  props: {
    show: Boolean,
    number: Number,
    value: Boolean,
  },
  components: {
    AgreementPop,
    Protocol,
  },
  methods: {
    handleAgree (value) {
      this.$emit('input', value)
    },
    handleConfirm (value) {
      this.$emit('confirm', value)
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
